export default class Produto {
  constructor(id, codigo, descricao, unidade, valor, data, peso) {
    this.id = id;
    this.codigo = codigo;
    this.descricao = descricao;
    this.unidade = unidade;
    this.valor = valor;
    this.data = data;
    this.peso = peso;
  }
}
